module.exports = __webpack_public_path__ + "img/git.4659d23d.png";